import _ from 'lodash';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const initExchange = {
  exchangeStep: 'step1',
  exchangeCurrency: [],
  bankNameList: [],
  bankList: {},
  bankSelect: -1,
  exchangeBtnDisabled: false,
  exchangeRequest: {},
  exchangeInit: {},
  stateAccount: {},
  isStateContact: false,
  isStateAccount: false,
  isDisplayAccount: false,

  exchangeAccountRequest: {},

  exchangeList: [],
  exchangeListPageSize: 10,
  exchangeListPageNo: 1,
  exchangeListStartDate: '',
  exchangeListEndDate: '',
  exchangeListStatus: 0,
  exchangeDetail: -1,
  isDetailAccount: false,
  isDetailStateAccount: false,

  isNjPointWithdraw: false,
};

const exchange = _.cloneDeep(initExchange);

const defaultState = {
  initExchange,
  exchange,
};

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations,
};
